__turbopack_context__.v({
  "root": "RubCurrency-module-scss-module__ID4RDG__root",
});
